// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.ImageBanner-container-kyUNM {
	width: 100%;
	max-width: var(--max-container-width);
	margin: 0 auto;
	padding: 0;
}
.ImageBanner-bgImage-dJ9DQ {
	min-height: 376px;
	background-repeat: no-repeat;
	background-size: cover;
	text-align: center;
	border-radius: 10px;
	margin: 100px 0;
	color: var(--common-primary-white-foreground);
	font-size: 46px;
}
.ImageBanner-bgImgeCenter-GS8p8 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	padding: 20px;
}
.ImageBanner-btn-vxz3y {
	display: inline-block;
	background-color: var(--common-white-primary-bg);
	color: var(--primary-bg) !important;
	border-radius: 23px;
	padding: 10px 20px;
	text-align: center;
	font-size: 16px;
	text-decoration: none !important;
}
.ImageBanner-titleText-EiH86 {
	font-size: 46px;
	font-weight: 600;
	text-shadow: 0 6px 32px var(--primary-foreground);
}
@media screen and (max-width: 767px) {
	.ImageBanner-bgImage-dJ9DQ {
		margin: 55px 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/ImageBanner/ImageBanner.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;CACC,WAAW;CACX,qCAAqC;CACrC,cAAc;CACd,UAAU;AACX;AAEA;CACC,iBAAiB;CACjB,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,6CAA6C;CAC7C,eAAe;AAChB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,aAAa;AACd;AAEA;CACC,qBAAqB;CACrB,gDAAgD;CAChD,mCAAmC;CACnC,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iDAAiD;AAClD;AAEA;CACC;EACC,cAAc;CACf;AACD","sourcesContent":["/** RentAll - Begin **/\n.container {\n\twidth: 100%;\n\tmax-width: var(--max-container-width);\n\tmargin: 0 auto;\n\tpadding: 0;\n}\n\n.bgImage {\n\tmin-height: 376px;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\ttext-align: center;\n\tborder-radius: 10px;\n\tmargin: 100px 0;\n\tcolor: var(--common-primary-white-foreground);\n\tfont-size: 46px;\n}\n\n.bgImgeCenter {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px;\n}\n\n.btn {\n\tdisplay: inline-block;\n\tbackground-color: var(--common-white-primary-bg);\n\tcolor: var(--primary-bg) !important;\n\tborder-radius: 23px;\n\tpadding: 10px 20px;\n\ttext-align: center;\n\tfont-size: 16px;\n\ttext-decoration: none !important;\n}\n\n.titleText {\n\tfont-size: 46px;\n\tfont-weight: 600;\n\ttext-shadow: 0 6px 32px var(--primary-foreground);\n}\n\n@media screen and (max-width: 767px) {\n\t.bgImage {\n\t\tmargin: 55px 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImageBanner-container-kyUNM`,
	"bgImage": `ImageBanner-bgImage-dJ9DQ`,
	"bgImgeCenter": `ImageBanner-bgImgeCenter-GS8p8`,
	"btn": `ImageBanner-btn-vxz3y`,
	"titleText": `ImageBanner-titleText-EiH86`
};
module.exports = ___CSS_LOADER_EXPORT___;
